import { Routes, Route } from 'react-router-dom';
import Standard from './pages/Standard';
import Quiz from './pages/Quiz';

function App() {
  return (
      <Routes>
        <Route path="/" element={<Standard />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/standard" element={<Standard />} />
      </Routes>
  );
}

export default App;
